import {
  Component,
  Input,
  Output,
  HostListener,
  EventEmitter,
  Renderer2,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  OnInit,
  OnDestroy,
  OnChanges,
  AfterViewInit,
} from '@angular/core';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';
import { Router, ActivatedRoute } from '@angular/router';
import * as _ from 'lodash';
import * as moment from 'moment-timezone';
import { Angular2Csv } from 'angular2-csv';
import { DictionaryService } from 'app/shared/services/dictionary.service';
import { SharedService } from 'app/shared/services/shared.service';
import { HttpService } from 'app/shared/services/http.service';
import { GridService } from 'app/shared/services/grid.service';
import { ReportsService } from 'app/shared/services/reports.service';
import { UserService } from 'app/shared/services/user.service';
import { SupplyService } from 'app/shared/services/supply.service';
import { DemandService } from 'app/shared/services/demand.service';
import { GoogleAnalyticsService } from 'app/shared/services/google-analytics.service';

@AutoUnsubscribe()
@Component({
  selector: 'grid-component',
  templateUrl: './grid.component.html',
  styleUrls: ['./grid.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GridComponent implements OnInit, OnDestroy, OnChanges, AfterViewInit {
  @Input() public data: Array<any>;
  @Input() public dataTotal: Array<any>;
  @Input() public columnsSettings: Array<any>;
  @Input() public gridName: string;
  @Input() public labsVer: number;
  @Input() public tabsData: Array<any>;
  @Input() public selectedTab: number;
  @Input() public isReport: boolean;
  @Input() public isReportAdmin: boolean;
  @Input() public isBigReport: boolean;
  @Input() public isLoading: boolean;
  @Input() public isError: boolean;
  @Input() public isEmpty: boolean;
  @Input() public isExporting: boolean;
  @Input() public isDemandGrid: boolean;
  @Input() public queryParams: any;
  @Input() public showDemandStatus: boolean;
  @Input() public isColumnsLoaded: boolean;
  @Input() public ignoreLimitAssign: boolean;
  public isUpdating: boolean;
  public initFlag: boolean;
  public gridStringName: string;
  @Input() public parentInfo: any;
  @Input() public showElementsWhileLoading: boolean;
  @Input() public frontEndFiltering: boolean;
  @Input() public frontEndSorting: boolean;
  @Input() public frontEndPagination: boolean;
  @Input() public sortCell: string;
  @Input() public sortDir: string;
  @Input() public sortOverride: any;
  @Input() public showSearchBar: boolean;
  @Input() public showSearchBarMenuButton: boolean;
  @Input() public showSearchBox: boolean;
  @Input() public showSubIdSearchBox: boolean;
  @Input() public searchBoxToggle: any;
  @Input() public hideRefreshButton: boolean;
  @Input() public enableSelectAll: boolean;
  @Input() public onSelectAllConfirm: boolean;
  @Input() public enableSelect: boolean;
  @Input() public allowSelectIneligible: boolean;
  @Input() public reportFetching: boolean;
  @Input() public autoHeight: boolean;
  public isPublisher: boolean;
  public displayedData: Array<any>;
  public displayedDataTotal: Array<any>;
  public columns: Array<any>;
  public visibleColumns: Array<any>;
  public columnsForOptionsMenu: Array<any>;
  public columnsVisibilityChange: boolean;
  public dataPages: Array<any>;
  @Input() public currDataPage: number;
  @Input() public itemsPerPage: number;
  public selectedRowId: number;
  public filters: any;
  public currFilterOptions: Array<any>;
  @Input() public parentFilters: any;
  @Input() public overrideSelectFilters: boolean;
  @Input() public allowMultipleSelectFilter: boolean;
  @Input() public overrideReportTooltips: boolean;
  @Input() public linkColumns: Array<any>;
  @Input() public linkInNewTab: boolean;
  @Input() public caretLinks: boolean;
  @Input() public disabledRowsTooltip: string;
  public toggledColumnOptions: any;
  public isColumnOptionsFixedToLeft: boolean;
  public searchQuery: string;
  public subIdSearchQuery: string;
  public gridWidth: number;
  public maxColumnWidthAdd: number;
  public resizableColumns: number;
  public gridWidthDiff: number;
  public gridBodyHeight: number;
  public gridNavArrowsHeight: number;
  public gridCommonHeaderHeight: number;
  public gridOnlyHeaderHeight: number;
  public hScroll: number;
  public hScrollState: boolean;
  public scrollAmount: number;
  public actionsMargin: number;
  public gridOptionsMenuToggleStatus: boolean;
  public gridOptionsMenuX: number;
  public gridOptionsMenuY: number;
  @Input() public showExportVisibleButton: boolean;
  @Input() public showExportAllButton: boolean;
  @Input() public exportAllInFrontEnd: boolean;
  @Input() public aggregateData: boolean;
  @Input() public emptyDataSettings: any;
  public resizeColumnKey: string;
  public resizeStartX: number;
  public resizeStartWidth: number;
  public resizeIndicatorX: number;
  public resizeIndicatorHeight: number;
  public gridVerticalScroll: boolean;
  public mouseMoveListener: any;
  public mouseUpListener: any;
  public minColumnWidth: number;
  public selectedItems: Array<any>;
  public selectedItemsIDs: Array<string>;
  public selectedItemsDisplayedCount: number;
  public allSelectedState: boolean;
  public defaultSettings: any;
  @Input() public selectedAsAssigned: boolean;
  @Input() public isCedatoLabs: boolean;
  @Input() public isAssignGrid: boolean;
  @Input() public isLegacyPublishers: boolean;
  public reportFloatingBarKey: string;
  public reportFloatingBarTimeout: any;
  public reportFloatingBarState: boolean;
  public reportFloatingBarX: number;
  public reportFloatingBarY: number;
  public reportFloatingBarItemId: string;
  public reportFloatingBarItemName: string;
  public reportFloatingBarEditLink: string;
  public reportFloatingBarTypeCedatoX: boolean;
  public reportFloatingBarFilterQueryParams: any;
  public subscriptions: Array<any>;
  public isMarketplace: boolean;
  public currentURI: string;
  public activeFiltersJSON: string;
  public isHeaderFiltersOn: boolean;
  public gridRedrawTimeout: any;
  public gridRedrawTimeoutVal: number;
  public delayTimer: number;
  public showPartnerReport: boolean;
  @Output() public onSortChangeEvent: EventEmitter<any>;
  @Output() public onFilterChangeEvent: EventEmitter<any>;
  @Output() public onPaginationEvent: EventEmitter<any>;
  @Output() public onEditClickEvent: EventEmitter<any>;
  @Output() public onCopyClickEvent: EventEmitter<any>;
  @Output() public onDeleteClickEvent: EventEmitter<any>;
  @Output() public onDownloadClickEvent: EventEmitter<any>;
  @Output() public onPricingClickEvent: EventEmitter<any>;
  @Output() public onPublishClickEvent: EventEmitter<any>;
  @Output() public onReportClickEvent: EventEmitter<any>;
  @Output() public onFinanceClickEvent: EventEmitter<any>;
  @Output() public onExportAllClickEvent: EventEmitter<any>;
  @Output() public onTabSelected: EventEmitter<number>;
  @Output() public onColumnsVisibilityChangeEvent: EventEmitter<any>;
  @Output() public onSearchBoxToggleChange: EventEmitter<boolean>;
  @Output() public onShowDemandStatusChanged: EventEmitter<boolean>;
  @Output() public onReportBreakDownByPartner: EventEmitter<any>;

  constructor(
    public router: Router,
    public route: ActivatedRoute,
    public renderer: Renderer2,
    public cdr: ChangeDetectorRef,
    public dictionaryService: DictionaryService,
    public sharedService: SharedService,
    public httpService: HttpService,
    public gridService: GridService,
    public userService: UserService,
    public supplyService: SupplyService,
    public demandService: DemandService,
    public reportsService: ReportsService,
    public ga: GoogleAnalyticsService
  ) {
    this.data = [];
    this.dataTotal = [];
    this.columnsSettings = [];
    this.gridName = '';
    this.gridStringName = '';
    this.tabsData = [];
    this.selectedTab = 0;
    this.isReport = false;
    this.isReportAdmin = false;
    this.isBigReport = false;
    this.isLoading = false;
    this.isError = false;
    this.isEmpty = false;
    this.isExporting = false;
    this.isUpdating = false;
    this.initFlag = true;
    this.isDemandGrid = false;
    this.showDemandStatus = false;
    this.parentInfo = {};
    this.queryParams = {};
    this.showElementsWhileLoading = true;
    this.frontEndFiltering = true;
    this.frontEndSorting = true;
    this.frontEndPagination = true;
    this.autoHeight = false;
    this.sortCell = '';
    this.sortDir = 'desc';
    this.sortOverride = {};
    this.showSearchBar = false;
    this.isPublisher = this.userService.isCedatoPublisher();
    this.showSearchBarMenuButton = false;
    this.showSearchBox = true;
    this.showSubIdSearchBox = false;
    this.searchBoxToggle = { enabled: false };
    this.hideRefreshButton = false;
    this.enableSelectAll = true;
    this.onSelectAllConfirm = false;
    this.enableSelect = true;
    this.allowSelectIneligible = true;
    this.displayedData = [];
    this.displayedDataTotal = [];
    this.columns = [];
    this.visibleColumns = [];
    this.columnsForOptionsMenu = [];
    this.columnsVisibilityChange = false;
    this.dataPages = [];
    this.currDataPage = 1;
    this.itemsPerPage = 50;
    this.selectedRowId = null;
    this.filters = {};
    this.currFilterOptions = [];
    this.parentFilters = {};
    this.overrideSelectFilters = false;
    this.allowMultipleSelectFilter = true;
    this.overrideReportTooltips = true;
    this.linkColumns = [];
    this.linkInNewTab = false;
    this.caretLinks = false;
    this.disabledRowsTooltip = '';
    this.toggledColumnOptions = null;
    this.isColumnOptionsFixedToLeft = false;
    this.searchQuery = '';
    this.subIdSearchQuery = '';
    this.gridWidth = 0;
    this.gridWidthDiff = 0;
    this.maxColumnWidthAdd = 50;
    this.gridBodyHeight = 0;
    this.gridNavArrowsHeight = 0;
    this.gridCommonHeaderHeight = 0;
    this.gridOnlyHeaderHeight = 0;
    this.hScroll = 0;
    this.hScrollState = false;
    this.scrollAmount = 8 * 15;
    this.gridOptionsMenuToggleStatus = false;
    this.showExportVisibleButton = true;
    this.showExportAllButton = false;
    this.exportAllInFrontEnd = false;
    this.aggregateData = false;
    this.emptyDataSettings = {
      title: 'NO_DATA',
      info: '',
      buttonText: '',
      buttonLink: '',
    };
    this.resizeColumnKey = null;
    this.resizeIndicatorX = 0;
    this.resizeIndicatorHeight = 0;
    this.gridVerticalScroll = false;
    this.minColumnWidth = 60;
    this.selectedItems = [];
    this.selectedItemsIDs = [];
    this.selectedItemsDisplayedCount = 0;
    this.allSelectedState = false;
    this.defaultSettings = {
      sortCell: this.sortCell,
      sortDir: this.sortDir,
    };
    this.selectedAsAssigned = false;
    this.isCedatoLabs = false;
    this.isAssignGrid = false;
    this.isLegacyPublishers = false;
    this.reportFloatingBarState = false;
    this.subscriptions = [];
    this.activeFiltersJSON = '';
    this.isColumnsLoaded = false;
    this.reportFetching = false;
    this.gridRedrawTimeoutVal = 800;
    this.ignoreLimitAssign = false;
    this.onSortChangeEvent = new EventEmitter<any>();
    this.onFilterChangeEvent = new EventEmitter<any>();
    this.onShowDemandStatusChanged = new EventEmitter<any>();
    this.onPaginationEvent = new EventEmitter<any>();
    this.onEditClickEvent = new EventEmitter<any>();
    this.onCopyClickEvent = new EventEmitter<any>();
    this.onDeleteClickEvent = new EventEmitter<any>();
    this.onDownloadClickEvent = new EventEmitter<any>();
    this.onPricingClickEvent = new EventEmitter<any>();
    this.onPublishClickEvent = new EventEmitter<any>();
    this.onReportClickEvent = new EventEmitter<any>();
    this.onFinanceClickEvent = new EventEmitter<any>();
    this.onExportAllClickEvent = new EventEmitter<any>();
    this.onTabSelected = new EventEmitter<number>();
    this.onColumnsVisibilityChangeEvent = new EventEmitter<any>();
    this.onSearchBoxToggleChange = new EventEmitter<boolean>();
    this.onReportBreakDownByPartner = new EventEmitter<any>();
    this.isMarketplace = false;
    this.isHeaderFiltersOn = localStorage.getItem('isHeaderFiltersOn') === 'true';
    this.currentURI = '';
    this.delayTimer = null;
    this.showPartnerReport = false;
  }

  ngOnDestroy() {
    clearTimeout(this.gridRedrawTimeout);
  }

  ngOnInit() {
    this.gridStringName = this.gridName.length
      ? this.gridName.replace(/\s+/g, '_').replace(/[\W]+/g, '').toLowerCase()
      : 'legacy';
    this.defaultSettings = {
      sortCell: this.sortCell,
      sortDir: this.sortDir,
    };
    this.currentURI = this.router.url.split('?')[0];
    clearTimeout(this.gridRedrawTimeout);
    this.subscriptions.push(
      this.sharedService.getMessagesBus().subscribe((response: any) => {
        if (response.type === 'NETWORK_CHANGE') {
          this.rebuildColumnSettings().then(() => {
            this.detectChanges();
          });
        } else if (response.type === 'GRID_REDRAW') {
          this.isLoading = true;
          this.initGrid().then(() => {
            this.updateGrid(true).then(() => {
              this.isLoading = false;
              this.onScroll();
            });
          });
        } else if (response.type === 'GRID_DETECT_CHANGES') {
          this.detectChanges();
        } else if (response.type === 'GRID_SELECTION_CHANGE_CONFIRM') {
          this.selectAll();
        } else if (response.type === 'MODAL_HIDE') {
          if (response.data.component === 'confirm-assign') {
            this.updateSelectedItems();
          }
        } else if (response.type === 'GRID_UPDATE_SELECTED_ITEMS') {
          this.updateSelectedItems();
        }
      })
    );
    this.isMarketplace = this.userService.getFeatureState('cedatox_marketplace');
  }

  ngAfterViewInit() {
    this.cdr.detach();
  }

  ngOnChanges($event: any) {
    const mandatoryColumns: Array<any> = _.filter(this.gridService.columnsDefaults, { mandatory: true });
    this.currentURI = this.router.url.split('?')[0];
    this.loadCustomSettings();
    // If we got new data in this event...
    if ($event.data) {
      if (this.data === undefined) {
        this.data = [];
      }
      // Remove feature-flagged columns
      for (let i: number = this.columnsSettings.length - 1; i > -1; i--) {
        if (this.columnsSettings[i] && this.columnsSettings[i].featureFlag) {
          if (!this.userService.getFeatureState(this.columnsSettings[i].featureFlag)) {
            this.columnsSettings.splice(i, 1);
          }
        }
      }
      // Initialize special columns
      mandatoryColumns.forEach((column: any) => {
        if (!_.find(this.columnsSettings, { key: column.key })) {
          this.columnsSettings.push({ key: column.key });
        }
      });
      // Initialize itemId values
      for (let i = 0; i < this.data.length; i++) {
        this.data[i].$$itemId = i + 1;
      }
      // Reset the horizontal scroll
      this.hScroll = 0;
      // Initialize the grid, and update the UI
      this.initGrid().then(() => {
        this.updateGrid(true).then(() => {
          if (this.isCedatoLabs) {
            this.updateTotalRow();
          }
        });
      });
    }
    if ($event.dataTotal) {
      this.updateTotalRow();
    }

    if ($event.isLoading) {
      this.detectChanges();
      if (!this.isLoading) {
        this.initFlag = false;
      }
    }
  }

  initGrid() {
    return new Promise((resolve) => {
      let columnDefaults: any;
      let columnWidth: number;
      let currValue: any;
      // Reset values
      this.gridOptionsMenuToggleStatus = false;
      this.toggledColumnOptions = null;
      this.columns = [];
      // Add the report dummy cell if needed
      if (this.isCedatoLabs && _.find(this.columnsSettings, { key: '$$reportDummy' }) === undefined) {
        this.columnsSettings.push({ key: '$$reportDummy' });
      }
      // For all of the columns...
      this.columnsSettings.forEach((column: any) => {
        // Find the columns default settings
        columnDefaults = column ? this.gridService.getColumnDefaults(column) : undefined;
        if (!column) {
          return false;
        }

        // Get the column width
        if (column.width !== undefined) {
          columnWidth = column.width;
        } else if (columnDefaults !== undefined) {
          columnWidth = columnDefaults.width !== undefined ? columnDefaults.width : this.gridService.defaultColumnWidth;
        } else {
          columnWidth = this.gridService.defaultColumnWidth;
        }
        // Get the column value
        currValue = this.sharedService.isEmpty(column.label) ? '' : this.dictionaryService.get(column.label);
        // Initialize the column values
        this.columns.push({
          key: column.key,
          value: currValue,
          width: columnWidth,
          defaultWidth: columnWidth,
          defaultVisibility: column.defaultVisibility,
          hidecedatox: column.hidecedatox,
          visible: column.hasOwnProperty('visible')
            ? column.visible
            : column.hasOwnProperty('defaultVisibility')
            ? column.defaultVisibility
            : true,
          optionsToggleStatus: false,
          rightAligned: columnDefaults ? columnDefaults.rightAligned : '',
          filterMeasurementChar:
            columnDefaults && columnDefaults.filterMeasurement ? columnDefaults.filterMeasurement.char : '',
          filterMeasurementAlign:
            columnDefaults && columnDefaults.filterMeasurement ? columnDefaults.filterMeasurement.align : '',
        });
        if (column.key === '$$active') {
          this.updateColumnFilterOptions(column);
        }
        // Pass the column's default values, where the column's settings is not defined
        if (columnDefaults !== undefined) {
          for (const property in columnDefaults) {
            if (columnDefaults.hasOwnProperty(property) && column[property] === undefined) {
              column[property] = columnDefaults[property];
            }
          }
        }
        // If this column has a filter, initialize it to an empty value
        this.initFilters(column);
      });

      resolve();
    });
  }

  initFilters(column: any) {
    let filterType: string;
    filterType = this.getColumnFilterType(column);
    if (!this.sharedService.isEmpty(filterType)) {
      if (!this.sharedService.isEmpty(this.parentFilters[column.key])) {
        this.filters[column.key] = _.cloneDeep(this.parentFilters[column.key]);
      } else {
        switch (filterType) {
          case 'INPUT':
          case 'DROPDOWN':
            this.filters[column.key] = '';
            break;
          case 'SELECT':
            this.filters[column.key] = [];
            break;
          case 'RANGE':
            this.filters[column.key] = {
              min: null,
              max: null,
            };
            break;
        }
      }
    }
  }

  updateGrid(resetPagination: boolean = false) {
    return new Promise((resolve) => {
      let currColumn: any;
      let passedAllFilters: boolean;
      let passedCurrentFilter: boolean;
      let passedSearch: boolean;
      let cellValue: any;
      let filterValue: any;
      let filterType: string;
      const nonEmptyFilters: any = {};
      let sortingValues: Array<any>;
      let firstSortedValue: string;
      let isNumericSort: boolean;
      let numOfItemsInPage: number;
      const notProvidedBySource: string = this.dictionaryService.get('NOT_PROVIDED_BY_SOURCE').toLowerCase();
      const nonMandatoryVisibleColumns: Array<any> = [];
      // Reset data
      this.displayedData = [];
      this.dataPages = [];
      // Visible columns initialization
      this.visibleColumns = [];

      for (let i = 0; i < this.columns.length; i++) {
        currColumn = _.find(this.columnsSettings, { key: this.columns[i].key });

        if (!currColumn.hasOwnProperty('visible')) {
          this.columns[i].visible = currColumn.hasOwnProperty('defaultVisibility')
            ? currColumn.defaultVisibility
            : true;
        } else {
          this.columns[i].visible = currColumn.visible;
        }

        if (this.columns[i].key.substr(0, 2) !== '$$') {
          nonMandatoryVisibleColumns.push(this.columns[i].key);
        }

        if (currColumn && this.columns[i].visible) {
          this.visibleColumns.push(this.columns[i]);
        }
      }
      // Update the options-menu columns
      this.updateColumnsForOptionsMenu();
      // If there's data at all...
      if (this.data.length > 0 && nonMandatoryVisibleColumns.length > 0) {
        // Filter
        for (const key in this.filters) {
          if (
            this.filters.hasOwnProperty(key) &&
            !this.sharedService.isEmpty(this.filters[key]) &&
            _.find(this.columnsSettings, { key: key })
          ) {
            nonEmptyFilters[key] = {
              type: _.find(this.columnsSettings, { key: key }).filterType,
              value: this.filters[key],
            };
          }
        }
        //pagination
        numOfItemsInPage =
          this.currDataPage < this.dataPages.length
            ? this.itemsPerPage
            : this.displayedData.length - this.itemsPerPage * (this.dataPages.length - 1);
        if (this.currDataPage > this.data.length / numOfItemsInPage) {
          this.currDataPage = Math.ceil(this.data.length / numOfItemsInPage);
        }

        if (nonEmptyFilters != {}) {
          for (let i = 0; i < this.data.length; i++) {
            passedAllFilters = true;
            passedSearch = true;
            if (this.frontEndFiltering) {
              for (const key in nonEmptyFilters) {
                cellValue = this.data[i][key];
                filterValue = nonEmptyFilters[key].value;
                filterType = nonEmptyFilters[key].type;
                passedCurrentFilter = true;
                switch (filterType) {
                  case 'INPUT':
                    if (cellValue !== null && cellValue !== undefined) {
                      cellValue = cellValue.toString().toLowerCase();
                      filterValue = filterValue.toString().toLowerCase();
                      passedCurrentFilter = cellValue.indexOf(filterValue) > -1;
                      if (key === 'domain') {
                        passedCurrentFilter =
                          passedCurrentFilter || (notProvidedBySource.indexOf(filterValue) > -1 && cellValue === '');
                      }
                    } else {
                      passedCurrentFilter = false;
                    }
                    break;
                  case 'SELECT':
                    if (
                      [
                        'environment',
                        'partner',
                        'supply_partner',
                        'demand_partner',
                        'accountManager',
                        'ev',
                        'pa',
                        'sm',
                      ].includes(key)
                    ) {
                      passedCurrentFilter = false;
                      for (let j = 0; j < filterValue.length; j++) {
                        passedCurrentFilter = passedCurrentFilter || _.isEqual(cellValue, filterValue[j]);
                      }
                    } else {
                      filterValue.map((item: any) => (item ? item.toString() : ''));
                      passedCurrentFilter =
                        filterValue.indexOf(cellValue) > -1 && !(cellValue === '' && filterValue.indexOf('') === -1);
                    }
                    break;
                  case 'DROPDOWN':
                    cellValue = cellValue.toString().toLowerCase();
                    filterValue = filterValue.toString().toLowerCase();
                    passedCurrentFilter = cellValue === filterValue;
                    break;
                  case 'RANGE':
                    cellValue =
                      cellValue && parseFloat(cellValue.toString().replace(/[^0-9.]/g, '')) > 0
                        ? parseFloat(cellValue.toString().replace(/[^0-9.]/g, ''))
                        : 0;
                    if (filterValue.min && !_.isNaN(parseFloat(filterValue.min.replace(/[^0-9.]/g, '')))) {
                      const minVal: number = filterValue.min ? parseFloat(filterValue.min.replace(/[^0-9.]/g, '')) : 0;
                      passedCurrentFilter = cellValue >= minVal;
                    }
                    if (
                      filterValue.max &&
                      _.isNumber(parseFloat(filterValue.max.replace(/[^0-9.]/g, ''))) &&
                      passedCurrentFilter
                    ) {
                      const maxVal: number = filterValue.max ? parseFloat(filterValue.max.replace(/[^0-9.]/g, '')) : 0;
                      passedCurrentFilter = cellValue <= maxVal;
                    }
                    break;
                }
                passedAllFilters = passedAllFilters && passedCurrentFilter;
              }
              if (!this.sharedService.isEmpty(this.searchQuery)) {
                passedSearch = false;
                for (let j = 0; j < this.columnsSettings.length; j++) {
                  const key = this.columnsSettings[j].key;
                  if (key.substr(0, 2) !== '$$') {
                    if (!this.sharedService.isEmpty(this.data[i][key])) {
                      if (this.data[i][key].toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1) {
                        passedSearch = true;
                        break;
                      }
                    }
                  }
                }
              }
            }
            if (passedAllFilters && passedSearch) {
              this.displayedData.push(this.data[i]);
            }
          }
        }
        // Sort
        if (_.find(this.columns, { key: this.sortCell }) !== undefined && this.frontEndSorting) {
          sortingValues = _.map(this.data, this.sortCell);
          _.remove(sortingValues, (item: any) => {
            return this.sharedService.isEmpty(item);
          });
          firstSortedValue = this.gridService.getCellValue(
            { key: this.sortCell, value: sortingValues[0] },
            this.columnsSettings
          );
          firstSortedValue = this.sharedService.cleanString(firstSortedValue, ['$', '%', ',']);
          isNumericSort = this.sharedService.isNumeric(firstSortedValue) || this.sortCell === 'hour';
          if (isNumericSort) {
            this.displayedData = _.orderBy(
              this.displayedData,
              [
                (entry: any) => {
                  let value: any = entry[this.sortCell];
                  if (!this.sharedService.isEmpty(value)) {
                    value = value.toString();
                    value = value.replace('%', '');
                    value = value.replace('$', '');
                    value = value.replace(',', '');
                  } else {
                    value = 0;
                  }
                  return parseFloat(value);
                },
              ],
              [this.sortDir]
            );
          } else {
            this.displayedData = _.orderBy(
              this.displayedData,
              [
                (entry: any) => {
                  let value: any = entry[this.sortCell];
                  let joinedValues: string;
                  if (value !== null && value !== undefined) {
                    if (!(value instanceof Object)) {
                      value = this.gridService.getCellValue({ key: this.sortCell, value: value }, this.columnsSettings);
                    } else {
                      joinedValues = '';
                      for (const item in value) {
                        if (value.hasOwnProperty(item)) {
                          joinedValues += value[item] + ',';
                        }
                      }
                      value = joinedValues;
                    }
                  } else {
                    value = '';
                  }
                  return value.toLowerCase();
                },
              ],
              [this.sortDir]
            );
          }
        }
        if (this.sortOverride.cell && this.frontEndSorting) {
          this.displayedData = _.orderBy(this.displayedData, [this.sortOverride.cell], [this.sortOverride.dir]);
        }
        // Reset pagination if needed
        if (resetPagination && this.frontEndFiltering) {
          this.currDataPage = 1;
        }
        if (this.aggregateData || this.showPartnerReport) {
          this.aggregateTotalData();
        }
        // Update the selected items array
        this.updateSelectedItems();
        // Parse values
        if (this.displayedData.length > 0) {
          for (let i = 0; i < Math.ceil(this.displayedData.length / this.itemsPerPage); i++) {
            this.dataPages[i] = [];
            if (i === this.currDataPage - 1) {
              for (let j = 0; j < this.itemsPerPage; j++) {
                if (i * this.itemsPerPage + j < this.displayedData.length) {
                  this.dataPages[i][j] = [];
                }
              }
            }
          }
          this.parseObjectsAsArrays();
        }
      }
      this.onResize('resize');
      resolve();
    });
  }

  // Refresh grid
  refreshGrid() {
    this.updateGrid(true).then(() => {
      this.sharedService.sendMessage('GRID_REFRESH');
    });
  }

  // Parse the data from objects to arrays (as *ngFor works only with iterables)
  parseObjectsAsArrays() {
    const numOfItemsInPage: number =
      this.currDataPage < this.dataPages.length
        ? this.itemsPerPage
        : this.displayedData.length - this.itemsPerPage * (this.dataPages.length - 1);
    let currRow: Array<any> = [];
    let currCell: any;
    let currKey: any;
    let currValue: any;
    let columnSettings: any;
    for (let i = 0; i < numOfItemsInPage; i++) {
      currRow = [];
      for (let j = 0; j < this.columnsSettings.length; j++) {
        if (
          _.find(this.visibleColumns, { key: this.columnsSettings[j].key }) &&
          this.displayedData.length > (this.currDataPage - 1) * this.itemsPerPage + i
        ) {
          currCell = {};
          currKey = this.columnsSettings[j].key;
          if (
            this.gridName === 'FEATURE_FLAGS' &&
            this.columnsSettings[j].key === 'publisher_hb' &&
            this.displayedData[(this.currDataPage - 1) * this.itemsPerPage + i]['publisher_io'] &&
            +this.displayedData[(this.currDataPage - 1) * this.itemsPerPage + i]['publisher_io'] === 0
          ) {
            currCell.disabled = true;
          }
          currValue = this.displayedData[(this.currDataPage - 1) * this.itemsPerPage + i][currKey];
          columnSettings = _.find(this.columnsSettings, { key: currKey });
          currCell.key = currKey;
          currCell.value = this.gridService.getCellValue({ key: currKey, value: currValue }, this.columnsSettings);
          currCell.tooltip = this.gridService.getCellValue(
            { key: currKey, value: currValue, disabled: currCell.disabled },
            this.columnsSettings,
            true
          );
          currCell.originalValue = currValue;
          currCell.primaryKey = !this.sharedService.isEmpty(columnSettings.primaryKey)
            ? columnSettings.primaryKey
            : false;
          currCell.isActiveButton = this.columnsSettings[j].isActiveButton || false;
          currCell.hidecedatox = this.columnsSettings[j].hidecedatox;
          if (currKey === '$$actions') {
            currCell.supplyx = this.displayedData[(this.currDataPage - 1) * this.itemsPerPage + i]['$$supplyx'];
            currCell.demandx = this.displayedData[(this.currDataPage - 1) * this.itemsPerPage + i]['$$demandx'];
          }
          currRow.push(currCell);
        }
      }
      this.dataPages[this.currDataPage - 1][i] = currRow;
    }
  }

  // Page-navigation
  goToPage(pageNumber: number, fromNavigation: boolean = true) {
    if (!fromNavigation || this.frontEndPagination) {
      const gridBody: HTMLElement = document.querySelector(`#${this.gridStringName}.grid .gridBody`);
      this.currDataPage = pageNumber;
      if (gridBody) {
        gridBody.scrollTop = 0;
      }
      this.updateGrid().then(() => {
        return;
      });
    } else {
      this.onPaginationEvent.emit(pageNumber);
    }
  }

  // Page-navigation middle-button
  getPaginationMiddleButton() {
    return this.currDataPage === 1
      ? 2
      : this.currDataPage === this.dataPages.length
      ? this.dataPages.length - 1
      : this.currDataPage;
  }

  // Update the total row
  updateTotalRow() {
    if (this.sharedService.getNumOfKeys(this.dataTotal) > 0) {
      const displayedDataTotal: Array<any> = [];
      let currKey: string;
      let currValue: string;
      this.columnsSettings.forEach((column: any) => {
        currKey = column.key;
        currValue =
          parseFloat(this.dataTotal[currKey]) === 0
            ? '0'
            : this.dataTotal[currKey]
            ? parseFloat(this.dataTotal[currKey].toString().split(',').join('')).toString()
            : '';
        if (
          (column.hasOwnProperty('visible') && column.visible !== false) ||
          (!column.hasOwnProperty('visible') && column.defaultVisibility !== false)
        ) {
          displayedDataTotal.push({
            key: currKey,
            hidecedatox: column.hidecedatox,
            value:
              currValue !== ''
                ? this.gridService.getCellValue({ key: currKey, value: currValue }, this.columnsSettings, false, true)
                : '',
          });
        }
      });
      this.displayedDataTotal = _.cloneDeep(displayedDataTotal);
    } else {
      this.displayedDataTotal = [];
    }
  }

  // Total data aggregation
  aggregateTotalData() {
    const dataTotal: any = {};
    let defaultSettings: any;
    let isAggregated: boolean;
    // Reset all columns to zero
    this.columnsSettings.forEach((column: any) => {
      isAggregated = false;
      defaultSettings = _.find(this.gridService.reportColumns, { actualKey: column.key });
      if (defaultSettings) {
        if (defaultSettings.aggregated) {
          isAggregated = true;
        }
      }
      if (column.aggregated) {
        isAggregated = true;
      }
      if (isAggregated) {
        dataTotal[column.key] = 0;
      }
    });
    // If there's any data at all..
    if (this.displayedData.length > 0) {
      // For all of the columns...
      for (const key in this.displayedData[0]) {
        // If this is an aggregated columns...
        if (dataTotal[key] !== undefined) {
          // Aggregate the data
          dataTotal[key] = this.gridService.aggregate(this.displayedData, this.columnsSettings, key);
        }
      }
    }
    // Update the data
    this.dataTotal = _.cloneDeep(dataTotal);
    this.gridService.dataTotal = _.cloneDeep(dataTotal);
    this.updateTotalRow();
  }

  getColumnTooltip(cell: any) {
    const columnSettings: any = _.find(this.columnsSettings, { key: cell.key });
    if (this.isReport && this.overrideReportTooltips) {
      return this.gridService.getReportColumnTooltip(cell, this.columnsSettings);
    } else {
      if (columnSettings) {
        if (columnSettings.tooltipKey) {
          return this.dictionaryService.get(columnSettings.tooltipKey);
        }
      }
      if (cell.key === '$$selected' && this.selectedAsAssigned) {
        return `#${cell.value} (${this.selectedItems.length})`;
      } else {
        return cell.value;
      }
    }
  }

  getCellWidth(cell: any) {
    let cellWidth: number = this.gridService.defaultColumnWidth;
    const column: any = _.find(this.columns, { key: cell.key });
    const columnSettings: any = _.find(this.columnsSettings, { key: cell.key });
    if (['$$itemId', '$$style', '$$link'].includes(cell.key) || (cell.key === '$$actions' && this.isReport)) {
      return 0;
    }
    if (column === undefined || columnSettings === undefined) {
      return cellWidth;
    }
    if (column.width !== undefined) {
      cellWidth = column.width;
    }
    if (columnSettings.resizable === undefined || columnSettings.resizable) {
      if (!this.isReport) {
        cellWidth += this.gridWidthDiff;
      } else if (!isNaN(this.gridWidthDiff)) {
        cellWidth += this.gridWidthDiff > this.maxColumnWidthAdd ? this.maxColumnWidthAdd : this.gridWidthDiff;
      }
    }
    return cellWidth;
  }

  getColumnIsResizable(cell: any) {
    const columnSettings: any = _.find(this.columnsSettings, { key: cell.key });
    if (!columnSettings || !columnSettings.hasOwnProperty('resizable')) {
      return true;
    }
    return columnSettings.resizable;
  }

  getRowLink(row: any, urlPart: string, linkType: string = 'link') {
    const linkColumn: any = _.find(row, { key: '$$' + linkType });
    let linkSegments: Array<string>;
    let url = '';
    let queryParamsArray: Array<string> = [];
    const queryParamsObject: any = {};
    if (linkColumn) {
      linkSegments = linkColumn.value.split('?');
      url = linkSegments[0];
      if (linkSegments.length > 1) {
        queryParamsArray = linkSegments[1].replace('?', '').split('&');
        queryParamsArray.forEach((param: string) => {
          queryParamsObject[param.split('=')[0]] = param.split('=')[1];
        });
      }
    }
    if (urlPart === 'url') {
      return url;
    } else if (urlPart === 'queryParams') {
      return queryParamsObject;
    } else {
      return '';
    }
  }

  isCellRightAligned(cell: any) {
    const columnSettings: any = _.find(this.columnsSettings, { key: cell.key });
    if (columnSettings) {
      if (columnSettings.rightAligned) {
        return columnSettings.rightAligned;
      }
    }
    return false;
  }

  isCellMandatory(cell: any) {
    const defaultSettings: any = _.find(this.gridService.columnsDefaults, { key: cell.key });
    if (defaultSettings) {
      if (defaultSettings.mandatory) {
        return defaultSettings.mandatory;
      }
    }
    return false;
  }

  updateColumnOptionsFixedToLeft() {
    const grid: HTMLElement = document.querySelector(`#${this.gridStringName}.grid`);
    const headerCells: Array<any> = Array.from(document.getElementsByClassName('headerCell'));
    let answer = false;
    if (this.toggledColumnOptions) {
      headerCells.forEach((cell: any) => {
        if (cell.attributes['data-key'] && cell.attributes['data-key'].value === this.toggledColumnOptions.key) {
          answer = cell.getBoundingClientRect().left < grid.getBoundingClientRect().left;
        }
      });
    }
    this.isColumnOptionsFixedToLeft = answer;
  }

  fixModalPosition(columnKey: string = '', toggleOption: boolean = false) {
    if (columnKey) {
      const gridHeaderWrapper: HTMLElement = document.querySelector(`#${this.gridStringName}.grid .gridHeaderWrapper`);
      const cell: NodeListOf<HTMLElement> = document.querySelectorAll('[data-key="' + columnKey + '"]');
      if (cell && cell.length > 0) {
        const optionsModal: NodeListOf<HTMLElement> = cell[0].querySelectorAll('.columnOptions');
        if (optionsModal && optionsModal.length > 0) {
          if (toggleOption) {
            optionsModal[0].style.left = '-9999px';
            setTimeout(() => {
              if (
                cell[0].getBoundingClientRect().left + optionsModal[0].getBoundingClientRect().width >
                gridHeaderWrapper.getBoundingClientRect().right
              ) {
                optionsModal[0].style.display = 'none';
                setTimeout(() => {
                  optionsModal[0].style.removeProperty('left');
                  optionsModal[0].style.removeProperty('display');
                  optionsModal[0].style.right = '0px';
                });
              } else {
                optionsModal[0].style.display = 'none';
                setTimeout(() => {
                  optionsModal[0].style.removeProperty('left');
                  optionsModal[0].style.removeProperty('display');
                });
              }
            }, 150);
          } else {
            optionsModal[0].style.removeProperty('right');
          }
        }
      }
    }
  }

  isHeaderCellBad(key: string) {
    switch (key) {
      case '$$selected':
        return _.filter(this.data, { $$badSelection: true }).length > 0;
      case '$$CPM':
        if (this.supplyService.isFixedCPM(this.parentInfo.costType)) {
          return (
            _.filter(this.data, (item: any) => {
              return parseFloat(item.$$CPM) < parseFloat(this.parentInfo.costValue);
            }).length > 0
          );
        } else {
          return false;
        }
      case 'fixed_cost':
        return (
          _.filter(this.data, (item: any) => {
            return this.supplyService.isFixedCPM(parseInt(item.cost_type))
              ? parseFloat(item.fixed_cost) > parseFloat(this.parentInfo.vast_cpm)
              : false;
          }).length > 0
        );
      default:
        return false;
    }
  }

  isCellHidden(key: string) {
    return key === 'capping_pause' ? !this.showDemandStatus : false;
  }

  isRowCellBad(row: any, key: string) {
    switch (key) {
      case 'fixed_cost':
        return this.getCellByRow(row, key, true) >= parseFloat(this.parentInfo.vast_cpm);

      case 'supply_partner':
      case 'demand_partner':
        return this.getCellByRow(row, key, true) === 'Not Defined';

      case 'domain':
      case 'app_bundle':
      case 'app_name':
        return this.getCellByRow(row, key, true) === 'Not provided by source';

      case 'supply_id':
      case 'demand_id':
      case 'hour':
      case 'day':
      case 'network_id':
        return this.getCellByRow(row, key, true) === '-1';

      default:
        return false;
    }
  }

  isIneligible(row: any) {
    return (
      this.supplyService.isFixedCPM(this.parentInfo.costType) &&
      this.getCellByRow(row, '$$CPM', true) < this.parentInfo.costValue
    );
  }

  isCPMCellEditable(row: any) {
    return this.isSelected(row) && !this.getCellByRow(row, '$$defaultCPM', true);
  }

  getClassToggleState(row: any, cell: any, className: string) {
    const style: any = _.find(row, { key: '$$style' });
    if (style) {
      if (style.originalValue) {
        if (style.originalValue.className === className) {
          return style.originalValue.cells === '*' ? true : style.originalValue.cells.indexOf(cell.key) > -1;
        }
      }
    }
    return false;
  }

  getColumnFilterType(cell: any) {
    const column: any = _.find(this.columnsSettings, { key: cell.key });
    const columnDefaults: any = _.find(this.gridService.columnsDefaults, { key: cell.key });

    if (column) {
      if (column.filterType !== undefined) {
        return column.filterType;
      }
    }
    if (columnDefaults) {
      if (columnDefaults.filterType) {
        return columnDefaults.filterType;
      }
    }
    return null;
  }

  isVisibleFilterIcon(cell: any) {
    const column: any = _.find(this.columnsSettings, { key: cell.key });

    return this.isHeaderFiltersOn
      ? !(column && column.filterType && column.filterType === 'INPUT')
      : !!(column && column.filterType);
  }

  updateColumnFilterOptions(cell: any) {
    let options: Array<any> = [];
    const keys: Array<any> = _.uniqWith(_.map(this.data, cell.key), _.isEqual);
    const sortBy: string = cell.key !== 'hour' ? 'value' : 'key';
    let columnSettings: any;
    let currValue: any;
    let currDate: any;
    let lastHour: number;
    let isLiveNotActive = false;
    const today: any = new Date();
    const selectedAsAssigned: boolean = cell.key === '$$selected' && this.selectedAsAssigned && !this.isReport;
    const labsOverride: boolean =
      this.isCedatoLabs &&
      ['supply_type', 'supply_method', 'demand_type', 'environment', 'hour', 'day'].includes(cell.key);
    if (!(cell.key === '$$selected' && this.isCedatoLabs)) {
      if (
        !this.overrideSelectFilters &&
        !['active', '$$active'].includes(cell.key) &&
        !selectedAsAssigned &&
        !labsOverride
      ) {
        for (let i = 0; i < keys.length; i++) {
          columnSettings = _.find(this.columnsSettings, { key: cell.key });
          currValue = keys[i];
          if (columnSettings) {
            if (columnSettings.parseTooltipFunction) {
              currValue = columnSettings.parseTooltipFunction({ value: currValue });
            }
          }

          if (_.find(options, { value: currValue }) === undefined) {
            options.push({
              key: this.sharedService.isNumeric(keys[i]) ? parseFloat(keys[i]) : keys[i],
              value: currValue,
            });
          }
        }
      } else {
        switch (cell.key) {
          case 'active':
          case '$$active':
            isLiveNotActive = cell.label === 'LIVE' || cell.value === 'Live';
            options = [
              {
                value: isLiveNotActive ? this.dictionaryService.get('YES') : this.dictionaryService.get('ACTIVE'),
                key: true,
              },

              {
                value: isLiveNotActive ? this.dictionaryService.get('NO') : this.dictionaryService.get('INACTIVE'),
                key: false,
              },
            ];
            break;
          case 'environment':
            options = [
              { value: this.dictionaryService.get('DESKTOP'), key: this.dictionaryService.get('DESKTOP') },
              { value: this.dictionaryService.get('MOBILE_WEB'), key: this.dictionaryService.get('MOBILE_WEB') },
              { value: this.dictionaryService.get('MOBILE_APP'), key: this.dictionaryService.get('MOBILE_APP') },
              { value: this.dictionaryService.get('CTV'), key: this.dictionaryService.get('CTV') },
            ];
            break;
          case 'player_type': // used by leagcy reports
            options = this.supplyService
              .getSupplyTypes(true)
              .map((type) => ({ value: this.dictionaryService.get(type.name), key: type.id }));
            break;
          case 'supply_type':
            this.supplyService.getSupplyTypes(true).forEach((type: any) => {
              options.push({
                value: this.dictionaryService.get(type.name),
                key: this.dictionaryService.get(type.name),
              });
            });
            break;
          case 'supply_method':
            this.supplyService.supplyMethods.forEach((type: any) => {
              options.push({
                value: this.dictionaryService.get(type.name),
                key: this.dictionaryService.get(type.name),
              });
            });
            break;
          case 'vast_type':
          case 'demand_type':
            this.demandService.getDemandTypes(false).forEach((type: any) => {
              options.push({
                value: this.dictionaryService.get(type.name),
                key: type.id,
              });
            });
            break;
          case '$$selected':
            options = [
              { value: this.dictionaryService.get('ASSIGNED'), key: true },
              { value: this.dictionaryService.get('NOT_ASSIGNED'), key: false },
            ];
            break;
          // Relevant only for Labs
          case 'day':
            if (this.parentInfo) {
              if (this.parentInfo.startDate && this.parentInfo.endDate) {
                currDate = _.cloneDeep(this.parentInfo.startDate);
                for (
                  let i = 0;
                  i <= moment.duration(moment(this.parentInfo.endDate).diff(this.parentInfo.startDate)).asDays();
                  i++
                ) {
                  if (i > 0) {
                    currDate.setDate(currDate.getDate() + 1);
                  }
                  options.push({
                    value: moment(currDate).format('YYYY-MM-DD'),
                    key: moment(currDate).format('YYYY-MM-DD'),
                  });
                }
              }
            }
            break;
          case 'capping_pause':
            options = [
              { value: this.dictionaryService.get('YES'), key: true },
              { value: this.dictionaryService.get('NO'), key: false },
            ];
            break;
          // Relevant only for Labs
          case 'hour':
            if (this.parentInfo && this.parentInfo.startDate && this.parentInfo.endDate) {
              if (
                this.parentInfo.startDate.toLocaleDateString('en-US') === today.toLocaleDateString('en-US') &&
                this.parentInfo.endDate.toLocaleDateString('en-US') === today.toLocaleDateString('en-US')
              ) {
                lastHour = parseInt(moment().utc().utcOffset(this.reportsService.getTimezoneOffset()).format('H')) + 1;
              } else {
                lastHour = 24;
              }
            } else {
              lastHour = 24;
            }
            for (let i = 0; i < lastHour; i++) {
              options.push({
                value: this.gridService.parseHour({ value: i }),
                key: i,
              });
            }
            break;
        }
      }
      options = _.sortBy(options, sortBy);
      if (_.find(this.columnsSettings, { key: cell.key })) {
        _.find(this.columnsSettings, { key: cell.key })['options'] = options;
      }
    }
    this.currFilterOptions = options;
  }

  getSelectFilterOptionState(cell: any, option: any) {
    return this.filters[cell.key]
      ? _.isPlainObject(option.key)
        ? !!_.find(this.filters[cell.key], option.key)
        : this.filters[cell.key].includes(option.key)
      : false;
  }

  onFilterChange(cell: string, value: string, clearFilter: boolean = false, option: string = '') {
    let index: number;
    const columnSettings: any = _.find(this.columnsSettings, { key: cell });
    let allowFilter: boolean = value ? value.length > 2 || !value.length : true;

    if (columnSettings) {
      if (
        columnSettings.filterType === 'DROPDOWN' ||
        clearFilter ||
        (columnSettings.filterType === 'RANGE' && ['min', 'max'].includes(option))
      ) {
        allowFilter = true;
      }

      if (allowFilter) {
        switch (columnSettings.filterType) {
          case 'INPUT':
            this.filters[cell] = value;
            break;

          case 'DROPDOWN':
            this.filters[cell] = value.toString();
            this.onFilterApply(_.find(this.columns, { key: cell }), true);
            break;

          case 'SELECT':
            if (this.filters[cell] && !(this.filters[cell] instanceof Array)) {
              this.filters[cell] = this.filters[cell].split(',');
            }
            if (value === '') {
              this.filters[cell] = [];
            } else {
              index = this.filters[cell].indexOf(value);
              if ((!this.frontEndFiltering || !this.allowMultipleSelectFilter) && !this.isCedatoLabs) {
                index = _.findIndex(this.filters[cell], value);
                if (this.filters[cell].length > 0) {
                  if (this.filters[cell][0] === value) {
                    index = 0;
                  } else {
                    this.filters[cell] = [];
                  }
                }
              }
              index > -1 ? this.filters[cell].splice(index, 1) : this.filters[cell].push(value);
            }

            this.onFilterApply(_.find(this.columns, { key: cell }), false);
            break;
          case 'RANGE':
            if (!clearFilter) {
              this.filters[cell][option] = !_.isNaN(parseFloat(value.toString().replace(/[^0-9.]/g, '')))
                ? value
                : null;
            } else {
              this.filters[cell] = {
                min: null,
                max: null,
              };
            }
            break;
        }
      }
    }
  }

  clearFilter(cell: any) {
    setTimeout(() => {
      this.onFilterChange(cell.key, '', true);
      this.onFilterApply(cell);
      if (_.find(this.columns, { key: cell.key })) {
        _.find(this.columns, { key: cell.key })['optionsToggleStatus'] = false;
      }
      this.detectChanges();
    });
  }

  onFilterSelectAll(cell: string) {
    this.filters[cell] =
      this.filters[cell].length === this.currFilterOptions.length ? [] : _.map(this.currFilterOptions, 'key');
    this.onFilterChangeEvent.emit(this.filters);
    this.updateGrid(true).then(() => {
      return;
    });
  }

  onSortChange(cell: string, dir: string) {
    this.sortCell = cell;
    this.sortDir = dir;
    this.onSortChangeEvent.emit({ sortCell: cell, sortDir: dir });
    if (this.frontEndSorting) {
      this.updateGrid(true).then(() => {
        return;
      });
    }
  }

  loadCustomSettings() {
    const oldColumnSettings = _.cloneDeep(this.columnsSettings);
    let customSettings: any = localStorage.getItem('customGridSettings');
    const customRTBColumnsSettings: any = JSON.parse(localStorage.getItem('rtbColumnsVisibility'));

    if (!this.sharedService.isEmpty(this.gridName) && this.gridName !== this.dictionaryService.get('CUSTOM_REPORT')) {
      if (this.sharedService.isEmpty(customSettings)) {
        localStorage.setItem('customGridSettings', '{}');
      } else {
        customSettings = JSON.parse(customSettings);
        this.columnsSettings.forEach((column: any) => {
          if (customSettings[this.gridName]) {
            column.visible = customSettings[this.gridName].visibleColumns.includes(column.key);
          }
        });
      }
    }

    this.columnsSettings.forEach((column: any) => {
      if (
        customRTBColumnsSettings &&
        !_.isEmpty(customRTBColumnsSettings, true) &&
        this.gridService.rtbColumns.includes(column.key)
      ) {
        column.visible = customRTBColumnsSettings.includes(column.key);
      }
    });

    if (
      !_.isEqual(
        _.filter(oldColumnSettings, (one) => {
          return !one.key.includes('$$') && !one.hasOwnProperty('isSupply') && one.hasOwnProperty('isDemand');
        }),
        _.filter(this.columnsSettings, (one) => {
          return !one.key.includes('$$') && !one.hasOwnProperty('isSupply') && one.hasOwnProperty('isDemand');
        })
      )
    ) {
      this.onColumnsVisibilityChangeEvent.emit(this.columnsSettings);
    }
  }

  saveCustomSettings() {
    if (!this.sharedService.isEmpty(this.gridName) && this.gridName !== this.dictionaryService.get('CUSTOM_REPORT')) {
      let customSettings: any = JSON.parse(localStorage.getItem('customGridSettings'));
      if (customSettings[this.gridName] === undefined) {
        customSettings[this.gridName] = {};
      }
      customSettings[this.gridName].visibleColumns = _.map(this.visibleColumns, 'key');
      localStorage.setItem('customGridSettings', JSON.stringify(customSettings));

      customSettings = _.map(
        _.filter(this.columnsSettings, (column: any) => {
          return column.visible === false;
        }),
        'key'
      );
      localStorage.setItem('customReportHiddenColumns', JSON.stringify(customSettings));
    }
  }

  resetToDefaultSettings() {
    let isVisible: boolean;
    let columnDefaults: any;
    let column: any;
    this.sortCell = this.defaultSettings.sortCell;
    this.sortDir = this.defaultSettings.sortDir;
    for (let i = 0; i < this.columns.length; i++) {
      this.columns[i].width = this.columns[i].defaultWidth;

      columnDefaults = this.isCedatoLabs
        ? _.find(this.gridService.columnsDefaults, { key: this.columns[i].key })
        : _.find(this.columnsSettings, { key: this.columns[i].key });

      isVisible = columnDefaults.hasOwnProperty('defaultVisibility') ? columnDefaults.defaultVisibility : true;

      column = _.find(this.columnsSettings, { key: this.columns[i].key });

      if (column !== undefined) {
        column.visible = isVisible;
      }
    }
    this.columnsVisibilityChange = true;
    this.showDemandStatus = false;
    this.onShowDemandStatusChanged.emit(false);
    this.updateColumnVisibility();
  }

  onColumnResizerMouseDown($event: any, key: string) {
    const column: any = _.find(this.columns, { key: key });
    this.resizeColumnKey = key;
    this.resizeStartX = this.sharedService.getMouseCoords($event, 'x');
    this.resizeStartWidth = column.width;
    this.mouseMoveListener = this.renderer.listen(document, 'mousemove', ($event: any) => {
      if (this.resizeColumnKey !== null) {
        this.resizeIndicatorX =
          this.sharedService.getMouseCoords($event, 'x') -
          document.querySelector(`#${this.gridStringName}.grid .gridWrapper`).getClientRects()[0].left;
        this.detectChanges();
      }
    });
    this.mouseUpListener = this.renderer.listen(document, 'mouseup', ($event: any) => {
      if (this.resizeColumnKey !== null) {
        const column: any = _.find(this.columns, { key: this.resizeColumnKey });
        const width: number = this.resizeStartWidth + ($event.clientX - this.resizeStartX);
        column.width = Math.max(width, this.gridService.minColumnWidth);
        this.resizeColumnKey = null;
        this.onResize('resize', 0);
        this.mouseMoveListener();
        this.mouseUpListener();
      }
    });
  }

  updateResizeIndicatorHeight() {
    const gridHeader: HTMLElement = document.querySelector(`#${this.gridStringName} .gridHeader`);
    const gridBody: HTMLElement = document.querySelector(`#${this.gridStringName} .gridBody`);
    if (gridHeader && gridBody) {
      this.resizeIndicatorHeight = gridHeader.clientHeight + gridBody.clientHeight;
    }
  }

  updateGridBodyHeight() {
    const gridBody: HTMLElement = document.querySelector(`#${this.gridStringName} .gridBody`);
    const gridData: HTMLElement = document.querySelector(`#${this.gridStringName} .gridData`);
    const gridHeader: HTMLElement = document.querySelector(`#${this.gridStringName} .gridHeaderWrapper`);
    const gridWrapper: HTMLElement = document.querySelector(`#${this.gridStringName} .gridWrapper`);
    const gridSearchBar: HTMLElement = document.querySelector(`#${this.gridStringName} .searchBar`);
    const gridTabs: HTMLElement = document.querySelector(`#${this.gridStringName} .tabs`);

    let commonGridHeaderHeight = 0;
    if (gridBody) {
      this.gridVerticalScroll = gridData ? gridData.getBoundingClientRect().height > this.gridBodyHeight : false;
      if (gridHeader) {
        commonGridHeaderHeight = gridHeader.getBoundingClientRect().height;
      }

      if (gridSearchBar) {
        commonGridHeaderHeight += gridSearchBar.getBoundingClientRect().height;
      }

      if (gridTabs) {
        commonGridHeaderHeight += gridTabs.getBoundingClientRect().height;
      }

      this.gridCommonHeaderHeight = commonGridHeaderHeight;
      this.gridOnlyHeaderHeight = commonGridHeaderHeight - gridHeader.getBoundingClientRect().height;
      this.gridBodyHeight = gridWrapper.getBoundingClientRect().height - gridHeader.getBoundingClientRect().height;
      this.gridNavArrowsHeight = this.gridBodyHeight - 11;
      this.detectChanges();
    }
  }

  buildFrontEndCSVReport() {
    const data: Array<any> = [];
    let currRow: Array<any> = [];
    let currCell: any;
    let currKey: any;
    let currValue: any;
    for (let i = 0; i < this.displayedData.length; i++) {
      currRow = [];
      for (let j = 0; j < this.columnsSettings.length; j++) {
        if (
          _.find(this.visibleColumns, { key: this.columnsSettings[j].key }) &&
          this.displayedData.length > (this.currDataPage - 1) * this.itemsPerPage + i
        ) {
          currCell = {};
          currKey = this.columnsSettings[j].key;
          currValue = this.displayedData[(this.currDataPage - 1) * this.itemsPerPage + i][currKey];
          currCell.key = currKey;
          currCell.value = this.gridService.getCellValue({ key: currKey, value: currValue }, this.columnsSettings);
          currCell.tooltip = this.gridService.getCellValue(
            { key: currKey, value: currValue, disabled: currCell.disabled },
            this.columnsSettings,
            true
          );
          currRow.push(currCell);
        }
      }
      data[i] = currRow;
    }
    return data;
  }

  exportToCSV(exportAll: boolean = false) {
    const allColumns: Array<any> = _.cloneDeep(this.columns);
    const mandatoryColumns: Array<any> = _.filter(_.cloneDeep(this.gridService.columnsDefaults), { mandatory: true });
    if (this.data.length > 0) {
      _.remove(allColumns, { key: '$$selected' });
      _.remove(allColumns, { key: '$$reportDummy' });
      mandatoryColumns.forEach((column: any) => {
        _.remove(allColumns, { key: column.key });
      });
      //CappingStatus
      if (!this.showDemandStatus) {
        _.remove(allColumns, { key: 'capping_pause' });
      }
      this.gridOptionsMenuToggleStatus = false;
      if (exportAll && !this.exportAllInFrontEnd) {
        this.onExportAllClickEvent.emit();
      } else {
        let exportedData: Array<any>;
        const csvData: Array<any> = [];
        let currRow: any = {};
        const columns: Array<string> = [];
        let columnSettings: any;
        let defaultSettings: any;
        let shouldAdd: boolean;
        // Fetch the exported data
        exportedData = exportAll
          ? this.exportAllInFrontEnd
            ? this.buildFrontEndCSVReport()
            : _.cloneDeep(this.data)
          : _.cloneDeep(this.dataPages[this.currDataPage - 1]);
        if (exportedData === undefined) {
          exportedData = [];
        }

        // Headers
        allColumns.forEach((column: any) => {
          columnSettings = _.find(this.columnsSettings, { key: column.key });
          defaultSettings = _.find(this.gridService.columnsDefaults, { key: column.key });
          shouldAdd = true;
          // Don't add the mandatory columns
          if (defaultSettings) {
            if (defaultSettings.mandatory) {
              shouldAdd = false;
            }
          }
          // If this is not an 'Export All Data' command done via the front-end, and this column is hidden, don't add it
          if (columnSettings) {
            if (
              !exportAll &&
              ((column.hasOwnProperty('visible') && column.visible === false) ||
                (!column.hasOwnProperty('visible') && column.defaultVisibility === false))
            ) {
              shouldAdd = false;
            }
          }
          if (column.hidecedatox) {
            shouldAdd = false;
          }

          // If this column should be added, add it to the headers row and save its key value
          if (shouldAdd) {
            currRow[column.key] = column.value;
            columns.push(column.key);
          }
        });
        csvData.push(currRow);
        // Rows
        if (exportAll) {
          exportedData.forEach((item: Array<any>) => {
            currRow = {};
            columns.forEach((cell: any) => {
              if (this.exportAllInFrontEnd) {
                const cellData = _.find(item, { key: cell }) || {};
                currRow[cell] =
                  cell === '$$active' ? this.gridService.getActiveLabel(cellData) : cellData.tooltip || '';
              } else {
                currRow[cell] = item[cell];
              }
            });
            csvData.push(currRow);
          });
        } else {
          exportedData.forEach((item: Array<any>) => {
            currRow = {};
            columns.forEach((cell: any) => {
              const currItem = _.find(item, { key: cell });
              currRow[cell] =
                cell === '$$active'
                  ? this.gridService.getActiveLabel(currItem)
                  : _.has(currItem, 'tooltip')
                  ? currItem.tooltip
                  : '';
            });
            csvData.push(currRow);
          });
        }
        // Export CSV
        new Angular2Csv(csvData, this.dictionaryService.get('EXPORTED_DATA'));
      }
    }
  }

  updateColumnsForOptionsMenu() {
    const columns: Array<any> = [];
    let columnSettings: any;
    let defaultSettings: any;
    let shouldAdd: boolean;
    this.columns.forEach((column: any) => {
      shouldAdd = column.key !== '$$reportDummy';
      columnSettings = this.isCedatoLabs
        ? _.find(this.gridService.columnsDefaults, { key: column.key })
        : _.find(this.columnsSettings, { key: column.key });

      defaultSettings = _.find(this.gridService.columnsDefaults, { key: column.key });
      if (columnSettings !== undefined) {
        if (columnSettings.disableHide) {
          shouldAdd = false;
        }
      }
      if (defaultSettings !== undefined) {
        if (defaultSettings.mandatory) {
          shouldAdd = false;
        }
      }
      if (shouldAdd) {
        columns.push(column);
      }
    });
    this.columnsForOptionsMenu = columns;
    this.columnsVisibilityChange = false;
  }

  clearFilters() {
    let clearedAnyFilter = false;
    for (const column in this.filters) {
      if (this.filters.hasOwnProperty(column) && !this.sharedService.isEmpty(this.filters[column])) {
        clearedAnyFilter = true;
        this.onFilterChange(column, '', true);
      }
    }
    if (clearedAnyFilter) {
      this.onFilterChangeEvent.emit(this.filters);
      this.gridOptionsMenuToggleStatus = false;
      if (!this.labsVer) {
        this.updateGrid(true).then(() => {
          return;
        });
      }
    }
  }

  toggleColumnVisibility(key: string) {
    let column: any = _.find(this.columnsSettings, { key: key });
    const rtbColumnsVisibility: Array<any> = [];
    if (column !== undefined) {
      column.visible = !column.hasOwnProperty('visible')
        ? column.hasOwnProperty('defaultVisibility')
          ? !column.defaultVisibility
          : false
        : !column.visible;
      this.columnsVisibilityChange = true;

      if (this.gridService.rtbColumns.includes(key)) {
        for (let i = 0; i < this.gridService.rtbColumns.length; i++) {
          column = _.find(this.columnsSettings, { key: this.gridService.rtbColumns[i] });
          if (column && column.hasOwnProperty('visible') && column.visible) {
            rtbColumnsVisibility.push(column.key);
          }
        }
        localStorage.setItem('rtbColumnsVisibility', JSON.stringify(rtbColumnsVisibility));
      }
    }
  }

  showFiltersInHeader() {
    const filteredColumns: any = _.countBy(this.columnsSettings, { filterType: 'INPUT' });
    const filteredHiddenColumns: any = _.countBy(this.columnsSettings, { filterType: 'INPUT', visible: false });

    if (filteredColumns.true !== filteredHiddenColumns.true) {
      this.isHeaderFiltersOn = !this.isHeaderFiltersOn;
      localStorage.setItem('isHeaderFiltersOn', String(this.isHeaderFiltersOn));
      this.gridOptionsMenuToggleStatus = !this.gridOptionsMenuToggleStatus;
    } else {
      if (this.isHeaderFiltersOn) {
        this.isHeaderFiltersOn = false;
        localStorage.setItem('isHeaderFiltersOn', String(this.isHeaderFiltersOn));
        this.gridOptionsMenuToggleStatus = false;
      }
    }
    setTimeout(() => {
      this.updateGridBodyHeight();
    }, 50);
  }

  updateColumnVisibility() {
    if (this.labsVer === 1) {
      this.updateColumnVisibilityRoutine();
    } else {
      this.gridRedrawTimeout = setTimeout(() => {
        this.updateColumnVisibilityRoutine();
      }, this.gridRedrawTimeoutVal);
    }
  }

  updateColumnVisibilityRoutine() {
    const visibleFilteredColumns: any = _.countBy(this.columnsSettings, { filterType: 'INPUT', visible: true });
    if (!visibleFilteredColumns.true) {
      this.showFiltersInHeader();
    }

    this.updateGrid().then(() => {
      this.onResize('resize');
      this.updateTotalRow();
      this.saveCustomSettings();
      this.onColumnsVisibilityChangeEvent.emit(this.columnsSettings);
    });
  }

  getColumnVisibilityState(key: string) {
    return !!_.find(this.visibleColumns, { key: key });
  }

  onValueChange(item: any, cell: any) {
    if (cell.hasOwnProperty('disabled') && cell.disabled) {
      return false;
    }
    this.sharedService.sendMessage('GRID_VALUE_CHANGE', {
      item,
      dataItem: this.gridService.getDataItem(this.data, item),
      changedValue: cell.key,
      filers: this.filters,
    });
  }

  onSelectAllChange() {
    const allSelectedState: boolean = _.filter(this.displayedData, { $$selected: false }).length === 0;
    if (this.onSelectAllConfirm) {
      this.allSelectedState = !allSelectedState;
      this.sharedService.sendMessage('GRID_SELECTION_CHANGE_ATTEMPT', this.allSelectedState);
    } else {
      this.selectAll();
    }
  }

  selectAll() {
    let allSelectedState = false;
    const selectCondition: any = {
      $$selected: false,
    };
    if (this.searchBoxToggle && this.searchBoxToggle.state === false) {
      selectCondition.limit_assign = false;
    }

    allSelectedState = !(_.filter(this.displayedData, selectCondition).length === 0) && this.displayedData.length > 0;

    this.displayedData.forEach((item: any) => {
      const find: any = _.find(this.data, { $$itemId: item.$$itemId });
      if (
        (find.limit_assign && this.searchBoxToggle && this.searchBoxToggle.state === true) ||
        !find.limit_assign ||
        !!this.ignoreLimitAssign
      ) {
        find.$$selected = allSelectedState;
      }
    });
    this.updateSelectedItems();
    this.sharedService.sendMessage('GRID_SELECTION_CHANGE', this.data);
  }

  getSelectedItemColor(item: any) {
    const index: number = _.findIndex(this.selectedItems, this.gridService.getDataItem(this.data, item));
    if (index > -1 && this.selectedItems.length <= this.reportsService.graphMaxItemsForSingleLines) {
      return this.reportsService.graphColors[index].name;
    }
    return '';
  }

  onGridItemSelectChange(item: any) {
    const dataItem: any = this.gridService.getDataItem(this.data, item);
    if (dataItem) {
      dataItem.$$selected = !dataItem.$$selected;
      dataItem.$$selected
        ? this.selectedItems.push(dataItem)
        : this.selectedItems.splice(this.selectedItems.indexOf(dataItem), 1);
      this.updateSelectedItems();
      this.onValueChange(item, '$$selected');
    }
  }

  updateSelectedItems() {
    this.selectedItems = _.filter(this.data, { $$selected: true });
    this.selectedItemsIDs = _.map(this.selectedItems, '$$itemId');
    this.allSelectedState =
      _.filter(this.displayedData, { $$selected: false }).length === 0 && this.displayedData.length > 0;
    this.selectedItemsDisplayedCount = _.filter(this.displayedData, { $$selected: true }).length;
    this.detectChanges();
  }

  isSelected(row: any) {
    return this.selectedItemsIDs.includes(this.getCellByRow(row, '$$itemId', true));
  }

  onGridCellMouseOver($event: any, row: any, cell: any) {
    let key: string = cell.key;
    let cellValue: any;
    let columnSettings: any;
    let isDimension: boolean;
    if (this.isCedatoLabs) {
      if (cell.key === 'supply_name') {
        key = 'supply_id';
      } else if (cell.key === 'demand_name') {
        key = 'demand_id';
      }
      columnSettings = _.find(this.gridService.reportColumns, { actualKey: key });
      if (columnSettings) {
        if (!this.isReportAdmin) {
          isDimension =
            _.find(this.reportsService['dimensions_v' + this.labsVer], { value: columnSettings.reportKey }) !==
            undefined;
        } else {
          isDimension =
            _.find(this.reportsService['adminDimensions' + this.labsVer], { value: columnSettings.reportKey }) !==
            undefined;
        }
        this.reportFloatingBarTimeout = setTimeout(() => {
          if (this.isReport && isDimension) {
            cellValue = _.find(row, { key: key });
            this.reportFloatingBarKey = key;
            this.reportFloatingBarItemId = cellValue.originalValue === null ? '' : cellValue.originalValue.toString();
            this.reportFloatingBarItemName = _.find(row, { key: cell.key }).value;
            this.reportFloatingBarState = true;
            this.reportFloatingBarTypeCedatoX = this.isTypeCedatoX(row);
            this.reportFloatingBarX = $event.target.getBoundingClientRect().left;
            this.reportFloatingBarY = $event.target.getBoundingClientRect().top;
            this.updateReportFloatingBarLinks();
            this.detectChanges();
          }
        }, 500);
      }
    }
  }

  isTypeCedatoX(row) {
    const action_item: any = _.find(row, { key: '$$actions' });
    if (!_.isUndefined(action_item)) {
      return this.reportFloatingBarKey == 'demand_id' ? +action_item.demandx === 1 : +action_item.supplyx === 1;
    } else {
      return false;
    }
  }

  onGridCellMouseOut() {
    clearTimeout(this.reportFloatingBarTimeout);
  }

  onFloatingBarMouseOut() {
    if (this.reportFloatingBarState) {
      this.reportFloatingBarState = false;
      this.detectChanges();
    }
  }

  updateReportFloatingBarLinks() {
    let path = '';
    const currQueryParams: any = _.cloneDeep(this.route.snapshot.queryParams);
    const dimensions: Array<string> = currQueryParams.d.split('--');
    const dimensionId: string = this.getDimensionIdByKey(null, this.reportFloatingBarKey).toString();
    switch (this.reportFloatingBarKey) {
      case 'supply_id':
        path = '/supply/manage/';
        break;
      case 'demand_id':
        path = '/demand/manage/';
        break;
    }
    this.reportFloatingBarEditLink = path + this.reportFloatingBarItemId;
    this.reportFloatingBarFilterQueryParams = currQueryParams;
    dimensions.forEach((item: string, index: number) => {
      item = item.split('=')[0];
      if (item === dimensionId) {
        dimensions[index] = `${dimensionId}=${this.reportFloatingBarItemId}`;
      }
    });
    this.reportFloatingBarFilterQueryParams.d = dimensions.join('--');
  }

  getDimensionIdByKey(reportKey: string, actualKey: string) {
    const dimensions: Array<any> = !this.isReportAdmin
      ? this.reportsService['dimensions_v' + this.labsVer]
      : this.reportsService['adminDimensions' + this.labsVer];
    let key: string;
    let reportColumn: any;
    let dimension: any;
    if (reportKey) {
      key = reportKey;
    } else if (actualKey) {
      reportColumn = _.find(this.gridService.reportColumns, { actualKey: actualKey });
      if (reportColumn) {
        key = reportColumn.reportKey;
      }
    }
    if (key) {
      dimension = _.find(dimensions, { value: key });
      return dimension ? parseInt(dimension.dimension_id) : null;
    } else {
      return null;
    }
  }

  selectTab(id: number) {
    this.selectedTab = id;
    this.onTabSelected.emit(id);
  }

  onEditClick(item: any) {
    this.onEditClickEvent.emit(item);
  }

  onCopyClick(item: any) {
    this.onCopyClickEvent.emit(item);
  }

  onDeleteClick(e, preventDefault, item: any) {
    if (preventDefault) {
      e.stopPropagation();
      e.preventDefault();
    }

    this.onDeleteClickEvent.emit(item);
  }

  onDownloadClick(item: any) {
    this.onDownloadClickEvent.emit(item);
  }

  onPricingClick(item: any) {
    this.onPricingClickEvent.emit(item);
  }

  onPublishClick(item: any) {
    this.onPublishClickEvent.emit(item);
  }

  onReportClick(item: any) {
    this.onReportClickEvent.emit(item);
  }

  onFinanceClick(item: any) {
    this.onFinanceClickEvent.emit(item);
  }

  getActionButonVisibility(type: string, row: any) {
    const actions: any = _.find(row, { key: '$$actions' });
    if (actions !== undefined) {
      if (actions.value !== 'false') {
        return actions.value.split(',').indexOf(type) > -1;
      }
    }
    return false;
  }

  getActionButtonLink(type: string, item: any) {
    let link: string = location.pathname + '';
    let linkAddon = '';
    let queryParams: any = {};
    let queryParamsString = '';
    let queryParamsArray: Array<string>;
    let currQueryParam: any;
    let currQueryParamValue: any;
    const actionsColumn: any = _.find(item, { key: '$$actions' });
    let actionSettings: any;
    let isAbsolute = false;
    if (actionsColumn) {
      actionSettings = _.find(actionsColumn.originalValue, { type: type });
      if (actionSettings) {
        if (actionSettings.link) {
          link = '';
          linkAddon = GridComponent.getItemId(item);
          if (actionSettings.linkOverride) {
            link += actionSettings.linkOverride;
            if (linkAddon && linkAddon.length) {
              link += GridComponent.getItemId(item);
            }
          } else {
            if (linkAddon && linkAddon.length) {
              link += GridComponent.getItemId(item);
            } else {
              link = GridComponent.getItemLink(item);
            }
          }
        }

        queryParamsString = link.split('?').length === 1 ? '' : link.split('?')[1];
        queryParamsArray = queryParamsString.length > 0 ? queryParamsString.split('&') : [];
        for (let i = 0; i < queryParamsArray.length; i++) {
          currQueryParam = queryParamsArray[i].split('=');
          currQueryParamValue = queryParamsArray[i].split('=');
          currQueryParamValue.splice(0, 1);
          queryParams[currQueryParam[0]] = currQueryParamValue.join('=');
        }
        link = link.split('?')[0];

        if (actionSettings.linkOverride && actionSettings.isAbsoluteURL) {
          link = actionSettings.linkOverride;
          queryParams = {};
          isAbsolute = actionSettings.isAbsoluteURL;
        }
      }
    }

    return { link, queryParams, isAbsolute, preventDefault: actionSettings.preventDefault };
  }

  static getItemId(item: any) {
    const primaryColumn: any = _.find(item, { primaryKey: true });
    if (primaryColumn) {
      return primaryColumn.value;
    }
    return '';
  }

  static getItemLink(item: any) {
    const linkColumn: any = _.find(item, { key: '$$link' });
    if (linkColumn) {
      return linkColumn.value;
    }
    return '';
  }

  getCellByRow(row: any, cell: string, getOriginalValue: boolean = false) {
    const cellObj: any = _.find(row, { key: cell });
    if (cellObj) {
      return !getOriginalValue ? cellObj.value : cellObj.originalValue;
    }
    return '';
  }

  getPartnerLink(type: string) {
    const itemType: number =
      this.reportFloatingBarKey === 'supply_id' ? 2 : this.reportFloatingBarKey === 'demand_id' ? 3 : 0;
    const params: any = { itemId: this.reportFloatingBarItemId, itemType };
    let link = '';
    const queryParams: any = _.cloneDeep(this.queryParams);
    this.httpService.post('vdsp_ws/getPartnerId', params).subscribe(
      (response: any) => {
        if (response.status !== 'ERROR') {
          const partner_id: string = response.partner_id;
          switch (this.reportFloatingBarKey) {
            case 'supply_id':
              // build partner demand link
              if (type == 'report') {
                queryParams.d = `2=${partner_id}`;
                queryParams.nid = response.network_id;
                queryParams.sqp = 1;
                link =
                  '/demand/all?' +
                  Object.keys(queryParams)
                    .map(function (prop) {
                      return [prop, queryParams[prop]].map(encodeURIComponent).join('=');
                    })
                    .join('&');
              } else {
                link = '/demand/manage/' + partner_id;
              }
              break;
            case 'demand_id':
              // build partner supply link
              if (type == 'report') {
                queryParams.d = `1=${partner_id}`;
                queryParams.nid = response.network_id;
                queryParams.sqp = 1;
                link =
                  '/supply/all?' +
                  Object.keys(queryParams)
                    .map(function (prop) {
                      return [prop, queryParams[prop]].map(encodeURIComponent).join('=');
                    })
                    .join('&');
              } else {
                link = '/supply/manage/' + partner_id;
              }
              break;
          }
          this.sharedService.saveQueryParamsOnNetworkChange = true;
          window.open(link, '_blank');
        } else {
          this.sharedService.showFlashMessage(this.dictionaryService.get('AN_ERROR_HAS_OCCURRED'), 'error');
        }
      },
      () => {
        this.sharedService.showFlashMessage(this.dictionaryService.get('AN_ERROR_HAS_OCCURRED'), 'error');
      }
    );
    return true;
  }

  getPartnerReport() {
    const itemType: number =
      this.reportFloatingBarKey === 'supply_id' ? 2 : this.reportFloatingBarKey === 'demand_id' ? 3 : 0;
    const params: any = { itemId: this.reportFloatingBarItemId, itemType };
    this.isLoading = true;
    this.reportFloatingBarState = false;
    this.httpService.post('vdsp_ws/getPartnerId', params).subscribe(
      (response: any) => {
        if (response.status === 'ERROR') {
          this.sharedService.showFlashMessage(this.dictionaryService.get('AN_ERROR_HAS_OCCURRED'), 'error');
          this.isLoading = false;
          return;
        }
        this.showPartnerReport = true;
        this.onReportBreakDownByPartner.emit({ partnerId: response.partner_id, networkId: response.network_id, demandId: this.reportFloatingBarItemId });
      });
  }

  isRowLocked(row: any) {
    if (this.searchBoxToggle && this.searchBoxToggle.state) {
      return false;
    }

    return this.gridName === 'LIST_ASSIGNED'
      ? _.find(row, { key: 'limit_assign' }) && _.find(row, { key: 'limit_assign' })['originalValue']
        ? _.find(row, { key: 'limit_assign' })['originalValue']
        : false
      : false;
  }

  isRowHasLimitAssign(row: any) {
    return _.find(row, { key: 'limit_assign' }) ? _.find(row, { key: 'limit_assign' })['originalValue'] : false;
  }

  updateGridHorizontalScroll() {
    this.hScrollState = this.gridWidthDiff === 0;
    this.detectChanges();
  }

  scrollGrid(direction: number) {
    const gridBody: HTMLElement = document.querySelector(`#${this.gridStringName}.grid .gridBody`);
    let scrollAmount: number = this.scrollAmount;
    if (gridBody) {
      if (direction < 0) {
        scrollAmount *= -1;
      }
      gridBody.scroll({ top: gridBody.scrollTop, left: gridBody.scrollLeft + scrollAmount, behavior: 'smooth' });
    }
  }

  isNavigationArrowDisabled(direction: number) {
    const gridBody: HTMLElement = document.querySelector(`#${this.gridStringName}.grid .gridBody`);
    if (gridBody) {
      return direction === 1
        ? gridBody.scrollWidth < gridBody.clientWidth + gridBody.scrollLeft + 5
        : gridBody.scrollLeft === 0;
    }
    return true;
  }

  onDataRowClick($event: any, row: any) {
    const path: any =
      $event.path || ($event.composedPath && $event.composedPath()) || this.sharedService.composedPath($event.target);
    const tags: Array<string> = _.map(path, (item: any) => {
      if (item) {
        if (item.tagName) {
          return item.tagName.toLowerCase();
        }
      }
      return '';
    });
    if (!tags.includes('checkbox-component') && !tags.includes('input')) {
      this.selectedRowId =
        this.selectedRowId === this.getCellByRow(row, '$$itemId', true)
          ? null
          : this.getCellByRow(row, '$$itemId', true);
    }
  }

  closeColumnOptions() {
    this.toggledColumnOptions = null;
    this.visibleColumns.forEach((cell: any) => {
      cell.optionsToggleStatus = false;
    });
  }

  onSubIdSearch() {
    this.sharedService.sendMessage('SUB_ID_SEARCH', this.subIdSearchQuery);
  }

  searchBoxToggleChange($event: any) {
    this.searchBoxToggle.state = $event;
    //this.onSearchBoxToggleChange.emit($event);
  }

  getAssignedTooltip() {
    let tooltip: string = this.allSelectedState
      ? this.dictionaryService.get('UNCHECK_TO_UNASSIGN_ALL')
      : this.dictionaryService.get('CHECK_TO_ASSIGN_ALL');
    switch (this.selectedTab) {
      case 1:
        tooltip += ' ' + this.dictionaryService.get('ELIGIBLE');
        break;
      case 2:
        tooltip += ' ' + this.dictionaryService.get('INELIGIBLE');
        break;
    }
    return tooltip;
  }

  detectChanges() {
    if (!this.cdr['destroyed']) {
      this.isMarketplace = this.userService.getFeatureState('cedatox_marketplace');
      this.cdr.detectChanges();
    }
  }

  removeFilters() {
    //this.parentFilters = {};
    this.filters = {};
    if (!this.sharedService.isEmpty(this.gridName)) {
      localStorage.removeItem(`grid-${this.gridName}-filters`);
    }
  }

  // On resize event-handling
  @HostListener('window:resize', ['$event'])
  onResize($event: any = null, timeout: number = 400) {
    if ($event && ($event === 'orientationchange' || $event === 'resize' || $event.type === 'resize')) {
      if (timeout > 0) {
        this.isUpdating = true;
        this.detectChanges();
      }
      setTimeout(() => {
        if (document.querySelector(`#${this.gridStringName}.grid .gridBody`)) {
          const gridBodyWidth: number = document.querySelector(`#${this.gridStringName}.grid .gridBody`).clientWidth;
          this.resizableColumns = 0;
          let columnDefaults: any;
          let isHidden: boolean;
          this.gridWidth = 0;
          for (let i = 0; i < this.visibleColumns.length; i++) {
            columnDefaults = this.visibleColumns[i] ? this.gridService.getColumnDefaults(this.visibleColumns[i]) : null;
            isHidden = false;
            if (columnDefaults) {
              if (columnDefaults.width) {
                isHidden = columnDefaults.width === 0 || (this.isReport && this.visibleColumns[i].key === '$$actions');
              }
            }
            if (this.visibleColumns[i] && this.visibleColumns[i].visible && !isHidden) {
              this.gridWidth += this.visibleColumns[i].width;
              if (this.visibleColumns[i].resizable === undefined || this.visibleColumns[i].resizable) {
                this.resizableColumns++;
              }
            }
          }
          if (this.gridWidth < gridBodyWidth) {
            this.gridWidthDiff = (gridBodyWidth - this.gridWidth) / this.resizableColumns;
            this.gridWidth = gridBodyWidth;
          } else {
            this.gridWidthDiff = 0;
          }

          this.onScroll(null, false);
          this.isUpdating = false;

          this.detectChanges();
          setTimeout(() => {
            this.updateGridBodyHeight();
            this.updateResizeIndicatorHeight();
            this.updateGridHorizontalScroll();
            this.isLoading = false;
          }, 400);
        }
      }, timeout);
    }
  }

  // On orientation change event
  @HostListener('window:orientationchange', ['$event'])
  onOrientationChange() {
    this.onResize('orientationchange');
  }

  // On scroll event
  onScroll($event: any = null, detectChanges: boolean = true) {
    const gridBody: HTMLElement = document.querySelector(`#${this.gridStringName} .gridBody`);
    const gridData: HTMLElement = document.querySelector(`#${this.gridStringName} .gridData`);
    const gridOptionButtons: HTMLElement = document.querySelector(`#${this.gridStringName} .gridOptionsButton`);
    const gridOptionsButtonWidth: number = gridOptionButtons && !this.isReport ? gridOptionButtons.clientWidth : 0;
    if (gridBody) {
      this.hScroll = gridBody.scrollLeft > 0 ? gridBody.scrollLeft * -1 : 0;
      //this.actionsMargin = Math.min(gridBody.clientWidth - gridOptionsButtonWidth + gridBody.scrollLeft, this.gridWidth - gridOptionsButtonWidth);
      this.actionsMargin = Math.min(
        gridBody.getBoundingClientRect().width - gridOptionsButtonWidth + gridBody.scrollLeft,
        this.gridWidth - gridOptionsButtonWidth
      );
      if (detectChanges) {
        this.detectChanges();
      }

      setTimeout(() => {
        if (gridBody && gridData) {
          this.gridVerticalScroll = gridBody.clientHeight < gridData.clientHeight;
        }
      });
    }
  }

  // On Key down
  onKeyDown($event: any, cell: any, clearFilter: boolean = false, option: string = '') {
    if (this.delayTimer) {
      clearTimeout(this.delayTimer);
    }

    this.delayTimer = setTimeout(() => {
      const val: any = $event && $event.target && $event.target.value ? $event.target.value.trim() : '';

      if (option && option.length) {
        this.filters[cell.key][option] = val;
      } else {
        this.filters[cell.key] = val;
      }
      this.onFilterChange(cell.key, val, false, option);
      if ($event.which === 13) {
        this.onFilterApply(cell);
      }
    }, 900);
  }

  onFilterApply(cell: any, isCloseOptions: boolean = true) {
    if (isCloseOptions) {
      this.closeColumnOptions();
      cell.optionsToggleStatus = false;
    }
    if (this.frontEndFiltering) {
      this.updateGrid(true).then(() => {
        return;
      });
    }
    this.onFilterChangeEvent.emit(this.filters);
  }

  rebuildColumnSettings() {
    return new Promise((resolve) => {
      let find: any;
      this.isPublisher = this.userService.isCedatoPublisher();
      this.removeFilters();
      this.gridService.buildReportColumns();
      this.gridService.buildMeasureColumns();
      this.gridService.buildColumnsDefaults();
      setTimeout(() => {
        _.forEach(this.columnsSettings, (one) => {
          find = _.find(this.columnsSettings, { key: one.key });
          if (!find) {
            find = _.find(this.gridService.columnsDefaults, { key: one.key });
          }
          if (find) {
            this.initFilters(find);
            find.filterType ? (one.filterType = find.filterType) : delete one.filterType;
            find.filterMeasurement ? (one.filterMeasurement = find.filterMeasurement) : delete one.filterMeasurement;
          }
        });
      });

      resolve();
    });
  }

  changeDemandCappingStatus() {
    this.showDemandStatus = !this.showDemandStatus;
    this.onShowDemandStatusChanged.emit(this.showDemandStatus);
  }

  // On click event
  @HostListener('document:click', ['$event'])
  onDocumentClick($event: any) {
    const path: any =
      $event.path || ($event.composedPath && $event.composedPath()) || this.sharedService.composedPath($event.target);
    const gridNAme = _.find(path, { id: 'grid' });
    //Exit if clicked on another Grid
    if (gridNAme && !gridNAme.classList.contains(this.gridStringName)) {
      return;
    }
    let clickedOnColumn = false;
    let clickedOnOptions = false;
    let clickedOnSortButton = false;
    let clickedInsideColumn = false;
    let clickedOnCleanButton = false;
    let clickedFilterButton = false;
    let clickedColumnKey: any = null;
    let thisColumn: any;
    let startColumnToggleStatus: boolean;
    let thisColumnToggleStatus = false;
    const isInputInHeader: boolean =
      path[0] &&
      path[0].nodeName &&
      path[0].nodeName.toLowerCase() === 'input' &&
      path[0].className.indexOf('inHeaderSearch') > -1;

    /*
      Toggle columns' options menu
    */
    for (let i = 0; i < path.length; i++) {
      clickedOnColumn = (clickedOnColumn || _.indexOf(path[i].classList, 'headerCell') > -1) && !isInputInHeader;
      clickedOnOptions = clickedOnOptions || _.indexOf(path[i].classList, 'columnOptions') > -1;
      clickedOnCleanButton = clickedOnCleanButton || _.indexOf(path[i].classList, 'fa-times') > -1;
      clickedOnSortButton = clickedOnSortButton || _.indexOf(path[i].classList, 'sortButton') > -1;
      clickedFilterButton = clickedFilterButton || _.indexOf(path[i].classList, 'filterButton') > -1;
      if (clickedOnColumn && clickedColumnKey === null) {
        if (path[i].attributes['data-key']) {
          clickedColumnKey = path[i].attributes['data-key'].value;
          thisColumn = _.find(this.columns, { key: clickedColumnKey });
          if (thisColumn) {
            thisColumnToggleStatus = thisColumn.optionsToggleStatus;
            clickedInsideColumn =
              clickedColumnKey === '$$selected'
                ? _.find(path, { localName: 'checkbox-component' }) !== undefined
                : false;
          }
        }
      }
    }

    for (let i = 0; i < this.columns.length; i++) {
      startColumnToggleStatus = this.columns[i].optionsToggleStatus;
      this.columns[i].optionsToggleStatus =
        this.columns[i].key === clickedColumnKey && !clickedInsideColumn
          ? (!this.columns[i].optionsToggleStatus || clickedOnOptions) && !clickedOnSortButton && !clickedOnCleanButton
          : false;
      if (this.columns[i].optionsToggleStatus) {
        this.activeFiltersJSON = JSON.stringify(this.filters);
        switch (this.getColumnFilterType(this.columns[i])) {
          case 'INPUT':
            setTimeout(() => {
              let columnOptions: any = Array.from(document.getElementsByClassName('columnOptions'));
              let input: any;
              if (columnOptions.length > 0) {
                columnOptions = _.find(columnOptions, (column: any) => {
                  if (column === undefined) {
                    return false;
                  } else if (column.classList === undefined) {
                    return false;
                  }
                  return !Array.from(column.classList).includes('hideElement');
                });
                if (columnOptions) {
                  input = columnOptions.getElementsByTagName('input');
                  if (input.length > 0) {
                    input[0].focus();
                  }
                }
              }
            }, 100);
            break;
          case 'SELECT':
          case 'DROPDOWN':
            this.updateColumnFilterOptions(this.columns[i]);
            break;
        }
      }

      /*
        Filter modal was opened and now closed, compare filters and apply if anything changed
      */
      if (
        (startColumnToggleStatus && startColumnToggleStatus !== this.columns[i].optionsToggleStatus) ||
        (this.columns[i].optionsToggleStatus && clickedFilterButton)
      ) {
        if (this.activeFiltersJSON !== JSON.stringify(this.filters) || clickedFilterButton) {
          this.onFilterApply(this.columns[i], clickedFilterButton);
        }
      }
    }

    this.toggledColumnOptions = _.find(this.columns, { optionsToggleStatus: true });
    if (this.toggledColumnOptions) {
      this.updateColumnOptionsFixedToLeft();
    }

    if (
      clickedColumnKey &&
      _.find(this.columns, { key: clickedColumnKey }) &&
      thisColumnToggleStatus !== _.find(this.columns, { key: clickedColumnKey })['optionsToggleStatus']
    ) {
      this.fixModalPosition(clickedColumnKey, !this.sharedService.isEmpty(this.toggledColumnOptions));
    }

    /*
      Toggle grid options menu
    */
    let clickedOnGridOptionsButton = false;
    let clickedOnGridOptionsMenu = false;
    const reportActions: HTMLElement = document.querySelector(`#${this.gridStringName} .reportActions`);
    const gridOptionsButton: HTMLElement = document.querySelector(`#${this.gridStringName} .gridOptionsButton`);
    const gridHeader: HTMLElement = document.querySelector(`#${this.gridStringName} .gridHeaderWrapper`);
    const gridSearchBar: HTMLElement = document.querySelector(`#${this.gridStringName} .searchBar`);
    const gridTabs: HTMLElement = document.querySelector(`#${this.gridStringName} .tabs`);
    for (let i = 0; i < path.length; i++) {
      clickedOnGridOptionsButton =
        clickedOnGridOptionsButton ||
        _.indexOf(path[i].classList, 'gridOptionsButton') > -1 ||
        path[i].id === 'gridOptionsButton';
      clickedOnGridOptionsMenu = clickedOnGridOptionsMenu || path[i].id === 'gridOptionsMenu';
    }
    if (clickedOnGridOptionsButton) {
      if (!this.gridOptionsMenuToggleStatus && !this.isReport) {
        this.gridCommonHeaderHeight = gridHeader.getBoundingClientRect().height;
        if (gridSearchBar) {
          this.gridCommonHeaderHeight += gridSearchBar.getBoundingClientRect().height;
        }
        if (gridTabs) {
          this.gridCommonHeaderHeight += gridTabs.getBoundingClientRect().height;
        }
      }
      this.gridOptionsMenuToggleStatus = !this.gridOptionsMenuToggleStatus;
    } else if (!clickedOnGridOptionsMenu) {
      this.gridOptionsMenuToggleStatus = false;
    }

    if (!this.showSearchBarMenuButton) {
      if (this.gridOptionsMenuToggleStatus && reportActions && gridOptionsButton && this.isReport) {
        this.gridOptionsMenuY =
          this.sharedService.layout === 'small'
            ? 0
            : (reportActions.offsetHeight - gridOptionsButton.offsetHeight * 1.5) * -1;
      }
    } else {
      this.gridOptionsMenuX = 0;
      this.gridOptionsMenuY = 0;
    }
    if (this.columnsVisibilityChange) {
      clearTimeout(this.gridRedrawTimeout);
      this.updateColumnVisibility();
    }

    /*
      Fire 'onResize' if the side-menu button was clicked
    */
    let clickedOnSideMenuButton = false;
    for (let i = 0; i < path.length; i++) {
      clickedOnSideMenuButton = clickedOnSideMenuButton || _.indexOf(path[i].classList, 'sideMenuButton') > -1;
    }
    if (clickedOnSideMenuButton) {
      this.onResize('resize');
    }

    // Detect changes
    this.detectChanges();
  }
}
